import { CustomTabs } from "../../../../../../components";
import { TMuiOptionTabType } from "../../../../../../components/molecules/custom-tab/custom-tab";
import TimelineSection from "./timeline-section";

const options: TMuiOptionTabType = [
    {
        title: "LINHA DO TEMPO",
        content: <TimelineSection />,
    },
    // {
    //     title: "GANTT",
    //     content: <GanttSection />,
    // },
];

function TimelineSectionContent() {
    return <CustomTabs tabOptions={options} />;
}

export default TimelineSectionContent;
